import React from 'react';
import {FormControl, FormGroup, InputGroup} from 'react-bootstrap';
// import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
// import SWTCarEditModal from '../../../view/workdoc/SWTCarEditModal';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
// import SWTNewCustomerModal from '../../../view/workdoc/SWTNewCustomerModal';
import Moment from 'moment';
import DatePicker from '../DatePicker';
const TODAY = Moment().format('L LT').replace(Moment().format('YYYY'), (Moment().format('YYYY')*1) + 543);
class SelectDateTime extends React.Component {

  constructor(...args) {
    super(...args);
    
    this.state = {
      time: ''
    }
    this.initial();
  }

  initial() {
    
  }

  onFormChange = (e) => {
    // {
    //   brand_id: e.value,
    //       brand: e.label,
    // }
    // this.props.onChange(e.value);

  };
  onDateChange = (date) => {
    console.log('date', date);
    this.props.onChange(date);
  };

  onSetDateTime() {
    let {time} = this.state
    let times = TODAY.split(' ');
    if (times.length>1)
      time = times[1]
    this.setState({time:time})
    this.props.onChange(TODAY);
  }

  onTimeChange(e) {
    let {time} = this.state
    time = e.target.value
    this.setState({time:time})
  }

  render() {
    const {
      // openModal,
      // closeModal,
      // store,
      formData,
      disabled,
      readonly,
      uiSchema
    } = this.props;
    let {time} = this.state
    if (this.props.name==='contact_date') {
      time = this.props.formContext.formData.receiving.contact_time
    } else if (this.props.name==='delivering_date') {
      let times = []
      if (typeof this.props.formContext.formData.delivering.delivering_date !== 'undefined') {
        times = this.props.formContext.formData.delivering.delivering_date.split(' ');
        if (times.length>1)
          time = times[1]
      }  
    }
    return (
      <div>
        {uiSchema['ui:time']
        ?
            <FormGroup style={{display:'flex'}}>
              <DatePicker
                  isBorder={true}
                  disabled={disabled}
                  readOnly={readonly}
                  showIcon={false}
                  showFooter={true}
                  popPlacement="bottom"
                  buddhistEra
                  value={formData}
                  onChange={this.onDateChange} 
              />
              <InputGroup>
                <FormControl value={time} onChange={this.onTimeChange.bind(this)} style={{width:'100px'}} />
                <InputGroup.Addon 
                  className='btn' 
                  onClick={this.onSetDateTime.bind(this)}
                >
                  <FontAwesome className='color-green' name='calendar-check-o'/>
                </InputGroup.Addon>
              </InputGroup>            
            </FormGroup>
        :
        <DatePicker
            disabled={disabled}
            readOnly={readonly}
            showIcon={true}
            showFooter={true}
            popPlacement="bottom"
            buddhistEra
            value={formData}
            onChange={this.onDateChange} />
        }    
      </div>      
    );
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectDateTime);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectDateTime.js